import Vuex from "vuex";

import Vue from "vue";

import { postAjax } from "../util/ajax";
import apiTypeMap from "./apiTypeMap";

Vue.use(Vuex);
const store = new Vuex.Store({
	state: {
		// 存储token
		Authorization: localStorage.getItem("Authorization") ? localStorage.getItem("Authorization") : "",
		header: true, //是否显示头部
		footer: true, //是否显示底部
		header_top: true, //是否显示头部->顶部状态栏
		suspension: false, //右侧悬浮状态
		userInfo: {}, //用户信息,
		navAry: [], //导航栏彩票数据
		alertState: true, //弹窗状态
		loginStatus: false, //登陆状态
		loginAfter: false, //登录弹窗状态
		tempStatus: false, //试玩状态
		lastLoginInfo: "", //上一次登录时间
		loginActiveName: "login",
		apiTypeMap, // 所有三方API信息
		userFavoritesLotteryList: [], // 用户收藏彩种集合
		chatRoomLink: "",
		quickWithdrawalState: false, // 極速提現显示状态
		bankIslocking: null,
	},

	mutations: {
		setLastLogin(state, str) {
			state.lastLoginInfo = str;
		},
		setTempStatus(state, boll) {
			state.tempStatus = boll;
		},
		setLoginAfter(state, boll) {
			if (boll.state) {
				state.loginActiveName = boll.state;
			}
			state.loginAfter = boll || boll.boll;
		},
		setLoginStatus(state, boll) {
			state.loginStatus = boll;
		},
		checkLoginAndRegister(state, payload) {
			state.loginActiveName = payload.active;
		},
		CHANGEALERTSTATE(state) {
			state.alertState = false;
		},
		// 修改token，并将token存入localStorage
		changeLogin(state, user) {
			state.Authorization = user.Authorization;
			localStorage.setItem("Authorization", user.Authorization);
		},
		// 退出登录
		uesrOut(state) {
			state.Authorization = null;
			state.loginStatus = false;
			state.userInfo = {};
			state.tempStatus = false;
			localStorage.removeItem("Authorization");
		},
		// 顶部导航状态
		setHead(state, header) {
			state.header = header;
		},
		// 底部栏状态
		setFoot(state, foot) {
			state.footer = foot;
		},
		// 用户个人信息栏
		setTop(state, heTop) {
			state.header_top = heTop;
		},
		// 右侧悬浮框
		rightDom(state, suspen) {
			state.suspension = suspen;
		},
		// 用户账户信息
		setUserInfo(state, data) {
			state.userInfo = data;
		},
		// 导航栏彩票数据
		setNavAry(state, data) {
			state.navAry = data;
		},

		// 获取第三方游戏平台分类类型
		setThirdGameCategory(state, data) {
			state.thirdGameCategory = data;
		},
		// 导航三方API数据
		setThirdGame(state, data) {
			state.thirdGame = data;
		},
		// 设置获取的用户收藏彩种集合
		setUserFavoritesLotteryList(state, data) {
			state.userFavoritesLotteryList = data;
		},
		// 取得聯繫上級連結
		setChatRoomLink(state, link) {
			state.chatRoomLink = link;
		},
		// 設置财务中心極速提現页面显示状态
		setQuickWithdrawalState(state, data) {
			state.quickWithdrawalState = data;
		},
		setBankIslocking(state, data) {
			state.bankIslocking = data;
		},
	},
	actions: {
		getChatRoomLink({ commit }) {
			let url = "/api/User/GetUserChatLink";
			postAjax(url).then(data => {
				if (data.IsSucess) {
					commit("setChatRoomLink", data.Data);
				}
			});
		},
		async getWithdrawalState({ commit }) {
			let url = "/api/Cash/GetWithdrawalState";
			const res = await postAjax(url);
			if (res.IsSucess) {
				commit("setQuickWithdrawalState", res.Data);
			}
			return res;
		},
		getBankIslocking({ commit }) {
			let url = "/api/User/GetBankIslocking";
			postAjax(url).then(data => {
				if (data.IsSucess) {
					commit("setBankIslocking", data.Data);
				}
			});
		},
	},
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js